var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none",
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.54,
    fillRule: "evenodd",
    d: "M15.468 4.398l-4.22-4.22C11.133.062 10.977 0 10.818 0H4.71c-.336 0-.609.273-.609.609v3.493H.61c-.336 0-.609.273-.609.609v14.68c0 .336.273.609.609.609h10.326c.336 0 .609-.273.609-.608v-3.494h3.493c.336 0 .61-.273.61-.609V4.829c0-.156-.06-.313-.179-.431zM14.429 14.68h-2.885V8.93c0-.157-.062-.313-.178-.43l-4.22-4.22c-.115-.114-.27-.178-.43-.178H5.32V1.217h4.89v3.611c0 .336.272.609.608.609h3.611v9.244zM1.217 18.783h9.11V9.539H6.715c-.336 0-.61-.272-.61-.608V5.32H1.218v13.463zM7.324 6.18l2.142 2.142H7.324V6.18zm4.102-1.96h2.142l-.32-.321-1.822-1.821V4.22z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.66c1865ec5a4c192e99c95017ca51461.svg";
export { ForwardRef as ReactComponent };